module.exports = __webpack_public_path__ + "img/reportedProductInspection.621c5990.svg";